import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { InstallAppBannerForMobile } from '@snapask/common-components';

import { getAppRegion } from 'reduxModules/app/selector';
import { sendGTMEvent } from 'reduxModules/googleTagManager/action';
import { NA } from 'constants/appDownloadType';
import { HOME_DOWNLOAD_CLICK } from 'constants/gtmEvent';
import useGetCurrentDevice from 'hooks/useGetCurrentDevice';
import { INSTALL_APP_IS_CLOSED } from 'constants/InstallApp';

function InstallAppForMobileHandler() {
  const dispatch = useDispatch();
  const { t } = useTranslation(['app', 'footer']);
  const appRegion = useSelector(getAppRegion);
  const { isMobile, isTablet } = useGetCurrentDevice();
  const [isShow, setIsShow] = useState(false);

  const closeInstall = () => {
    setIsShow(false);
    window.sessionStorage.setItem(INSTALL_APP_IS_CLOSED, true);
  };

  const inactive = useMemo(() => {
    const isTargetDevice = isMobile || isTablet;

    return !(isTargetDevice && isShow);
  }, [isMobile, isTablet, isShow]);

  const onDownloadClick = () => {
    dispatch(
      sendGTMEvent({
        eventName: HOME_DOWNLOAD_CLICK,
        data: {
          region: appRegion,
          type: NA,
        },
      }),
    );
  };

  useEffect(() => {
    const isClosed = window.sessionStorage.getItem(INSTALL_APP_IS_CLOSED);

    if (!isClosed) {
      setIsShow(true);
    }
  }, []);

  return (
    <InstallAppBannerForMobile
      downloadApp={t('app:mobile.cta')}
      downloadLink={t('footer:footer.download')}
      subtitle={t('app:mobile.description')}
      onDownloadClick={onDownloadClick}
      onClose={closeInstall}
      inactive={inactive}
    />
  );
}

export default InstallAppForMobileHandler;
